# frozen_string_literal: true

module Engine
  module Game
    module G1880Romania
    end
  end
end
